import { render, staticRenderFns } from "./ComponentBox.vue?vue&type=template&id=b7a8a5b8&scoped=true"
import script from "./ComponentBox.vue?vue&type=script&lang=js"
export * from "./ComponentBox.vue?vue&type=script&lang=js"
import style0 from "./ComponentBox.vue?vue&type=style&index=0&id=b7a8a5b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a8a5b8",
  null
  
)

export default component.exports